<div class="wrap" [ngClass]="{'fundraiser-theme': vars.pageName === 'campaign'}">
  <div class="content">
    <div class="sections">
      <div class="sections-1">
        <div class="title">My contribution goes to:</div>
        <div class="what">What is this?</div>
        <div class="popover-content">
          <div class="sub-title">One contribution, many helped</div>
          <div *ngIf="selected?.value" class="desc">Your contribution will be used to support the treatment of other critically ill patients like <span *ngFor="let b of multi_patient_beneficiaries; let i=index">{{b}} {{i<=multi_patient_beneficiaries.length-3 ? ', ' : i+1 !==multi_patient_beneficiaries.length ? ' and ' : ''}}</span>, there by saving more lives.</div>
          <div *ngIf="!selected?.value" class="desc">Your contribution will support the featured patient alone.</div>
        </div>
      </div>
      <div class="sections-2">
        <div class="drop-down">
          <mat-form-field (click)="clickEvent()" appearance="fill">
            <mat-select [formControl]="selected" (selectionChange)="onChange()">
              <mat-option *ngFor="let item of options" [value]="item.value">{{item.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>
</div>